export const ColorPresets = {
  blue: ['#FFFFFF', '#D8F1FF', '#A6DFFF'],
  green: ['#FFFFFF', '#D8FFDB', '#A6FFB7'],
  purple: ['#FFFFFF', '#E0D8FF', '#BBA6FF'],
  red: ['#FFFFFF', '#FFD8D8', '#FFA6A6'],
  yellow: ['#FFFFFF', '#FFFFD8', '#FFFFA6'],
  sparkle: ['#FF00FF', '#FFFF00', '#00FFFF'],
}
